import React from 'react'
import { Route, IndexRoute, IndexRedirect } from 'react-router'

import CmsPages from '../components/cms-pages/list'
import CreateCmsPage from '../components/cms-pages/create'
import ShowCmsPage from '../components/cms-pages/show'
import EditCmsPage from '../components/cms-pages/show/edit'
import EditCmsPageHeader from '../components/cms-pages/show/header'
import EditCmsPageBlocks from '../components/cms-pages/show/blocks'

import PostRoutes from './posts'

import InstitutionLandingPageBlockEditor from '../components/cms-fixed-pages/InstitutionLandingPageBlockEditor'
import FSPBlockEditor from '../components/cms-fixed-pages/FSPBlockEditor'
import WritingChallengeBlockEditor from '../components/cms-fixed-pages/WritingChallengeBlockEditor'
import AlumniBlockEditor from '../components/cms-fixed-pages/AlumniBlockEditor'
import GenericSessionBlockEditor from '../components/cms-fixed-pages/GenericSessionPageBlockEditor'
import ContactPageBlockEditor from '../components/cms-fixed-pages/ContactPageBlockEditor'
import EventsPageBlockEditor from '../components/cms-fixed-pages/EventsPageBlockEditor'

const CmsRoutes = (
  <Route path='cms'>
    <Route path='pages'>
      <IndexRoute component={CmsPages} />
      <Route path='create' component={CreateCmsPage} />
      <Route path=':cmsPageId' component={ShowCmsPage}>
        <IndexRedirect to='edit' />
        <Route path='edit' component={EditCmsPage} />
        <Route path='header' component={EditCmsPageHeader} />
        <Route path='blocks' component={EditCmsPageBlocks} />
      </Route>

    </Route>
    <Route path='fixed-pages'>
      <Route path='institution-landing-page' component={InstitutionLandingPageBlockEditor} />
      <Route path='fsp' component={FSPBlockEditor} />
      <Route path='writing-challenge' component={WritingChallengeBlockEditor} />
      <Route path='alumni' component={AlumniBlockEditor} />
      <Route path='generic' component={GenericSessionBlockEditor} />
      <Route path='contact-page' component={ContactPageBlockEditor} />
      <Route path='events-page' component={EventsPageBlockEditor} />
    </Route>
    {PostRoutes}
  </Route>
)

export default CmsRoutes
